<div class="container">
  <img class="close pointer" src="/assets/img/icons/close.svg" alt="close" mat-dialog-close />

  <img src="/assets/img/icons/app-icon.svg" alt="app-icon" />

  <h2>{{ 'DOWNLOAD_WALTIO_APP_TITLE' | translate }}</h2>

  <p class="body-14-med">{{ 'DOWNLOAD_WALTIO_APP_DESC' | translate }}</p>

  <img class="qr-code" src="/assets/img/icons/stores/qr-code.svg" alt="qr-code" />

  <section class="download-buttons">
    @switch (data.userPreferences?.language) {
      @case ('en') {
        <img class="pointer" src="/assets/img/icons/stores/en/appstore.svg" alt="appstore" (click)="goToAppStore()" />
        <img
          class="pointer"
          src="/assets/img/icons/stores/en/playstore.svg"
          alt="playstore"
          (click)="goToPlayStore()"
        />
      }

      @case ('es') {
        <img class="pointer" src="/assets/img/icons/stores/es/appstore.svg" alt="appstore" (click)="goToAppStore()" />
        <img
          class="pointer"
          src="/assets/img/icons/stores/es/playstore.svg"
          alt="playstore"
          (click)="goToPlayStore()"
        />
      }

      @default {
        <img class="pointer" src="/assets/img/icons/stores/fr/appstore.svg" alt="appstore" (click)="goToAppStore()" />
        <img
          class="pointer"
          src="/assets/img/icons/stores/fr/playstore.svg"
          alt="playstore"
          (click)="goToPlayStore()"
        />
      }
    }
  </section>
</div>
